module.exports = __webpack_public_path__ + "static/media/logo-tumblr.a3f62e33.svg";